import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MainDashboard } from './components/MainDashboard';
import { ClientDashboard } from './components/ClientDashboard';
import { BannerSetEditor } from './components/BannerSetEditor';
import { BannerEditor } from './components/BannerEditor';
import { UserManagement } from './components/UserManagement';
import { Login } from './components/Login';
import { UserProfile } from './components/UserProfile';
import { ToastContainer } from './components/ToastContainer';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <DndProvider backend={HTML5Backend}>
            <div className="min-h-screen bg-gray-50">
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<ProtectedRoute><MainDashboard /></ProtectedRoute>} />
                <Route path="/clients/:clientId" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
                <Route path="/clients/:clientId/banner-sets/:bannerSetId" element={<ProtectedRoute><BannerSetEditor /></ProtectedRoute>} />
                <Route path="/clients/:clientId/banner-sets/:bannerSetId/sizes/:sizeId" element={<ProtectedRoute><BannerEditor /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
              </Routes>
              <ToastContainer />
            </div>
          </DndProvider>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
};

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default App;